var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import client from 'apollo/client';
import INSURANCE_PLAN_FROM_ID from 'apollo/queries/INSURANCE_PLAN_FROM_ID';
export var DEFAULT_TITLE = 'Network';
export var getTierName = function (raw, planId) {
    var plan = (client.readQuery({
        query: INSURANCE_PLAN_FROM_ID,
        variables: { id: planId }
    }) || {}).insurance_plan;
    if (plan) {
        var tiers = __spreadArray(__spreadArray([], ((plan === null || plan === void 0 ? void 0 : plan.insurance_tiers) || []), true), ((plan === null || plan === void 0 ? void 0 : plan.default_insurance_tier) ? [plan.default_insurance_tier] : []), true);
        var tier = tiers.find(function (i) { return i.kind === raw; });
        return (tier === null || tier === void 0 ? void 0 : tier.name) || raw;
    }
    return raw;
};
export var getReadableTitle = function (planId, arr) {
    if (arr === void 0) { arr = []; }
    if (arr.length === 0)
        return DEFAULT_TITLE;
    var tierName = getTierName(arr[0], planId);
    var additionalCount = arr.length > 1 ? "+".concat(arr.length - 1) : '';
    return "".concat(DEFAULT_TITLE, ": ").concat(tierName, " ").concat(additionalCount);
};
export var getOptions = function (plan) {
    if (!plan)
        return [];
    var _a = plan.insurance_tiers, insurance_tiers = _a === void 0 ? [] : _a, defaultBenefit = plan.default_insurance_tier;
    var options = insurance_tiers.map(function (_a) {
        var id = _a.id, name = _a.name, kind = _a.kind;
        return ({
            label: name,
            value: kind,
            key: id
        });
    });
    if (defaultBenefit) {
        options.push({
            label: defaultBenefit.name,
            value: defaultBenefit.kind,
            key: defaultBenefit.id
        });
    }
    return options;
};
